import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Item from "../../components/Item";
import { Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch, useSelector } from "react-redux";
import { setItems } from "../../state";
import { apiGet } from "../../apis/api";
import FallbackItems from "../../components/FallbackItems";

// Base URL for Vercel Blob storage
const BLOB_BASE_URL = "https://eezvqt4vd5kslelz.public.blob.vercel-storage.com";

// Helper function to get image URL
const getImageUrl = (imageName) => {
  return `${BLOB_BASE_URL}/${imageName}`;
};

const ShoppingList = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("all");
  const items = useSelector((state) => state.cart.items);
  const breakPoint = useMediaQuery("(min-width:600px)");
  const [useFallback, setUseFallback] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function getItems() {
    try {
      const itemsJson = await apiGet("/api/items?populate=image");
      dispatch(setItems(itemsJson.data));
      setUseFallback(false);
    } catch (error) {
      console.error("Error fetching items:", error);
      setUseFallback(true);
    }
  }

  useEffect(() => {
    getItems();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Filter out items that are not objects (just in case)
  const validItems = Array.isArray(items)
    ? items.filter((item) => item && typeof item.category === "string")
    : [];

  const topRatedItems = validItems.filter(
    (item) => item.category === "topRated"
  );
  const newArrivalsItems = validItems.filter(
    (item) => item.category === "newArrivals"
  );
  const bestSellersItems = validItems.filter(
    (item) => item.category === "bestSellers"
  );

  // Fallback product data (realistic names and categories)
  const fallbackItems = [
    {
      id: 1,
      Name: "Blue Sneakers",
      price: 79.99,
      category: "Shoes",
      image: { url: getImageUrl("IMG_7861.PNG") },
    },
    {
      id: 2,
      Name: "White Sneakers",
      price: 89.99,
      category: "Shoes",
      image: { url: getImageUrl("IMG_7846.PNG") },
    },
    {
      id: 3,
      Name: "White T-Shirt",
      price: 24.99,
      category: "T-Shirts",
      image: { url: getImageUrl("IMG_7845.PNG") },
    },
    {
      id: 4,
      Name: "Black Joggers",
      price: 49.99,
      category: "Pants",
      image: { url: getImageUrl("IMG_7868.PNG") },
    },
    {
      id: 5,
      Name: "Black T-Shirt",
      price: 24.99,
      category: "T-Shirts",
      image: { url: getImageUrl("IMG_7844.PNG") },
    },
    {
      id: 6,
      Name: "Black Jeans",
      price: 59.99,
      category: "Pants",
      image: { url: getImageUrl("IMG_7829.PNG") },
    },
    {
      id: 7,
      Name: "Pink T-Shirt",
      price: 29.99,
      category: "T-Shirts",
      image: { url: getImageUrl("IMG_7816.PNG") },
    },
    {
      id: 8,
      Name: "Red T-Shirt",
      price: 29.99,
      category: "T-Shirts",
      image: { url: getImageUrl("IMG_7808.PNG") },
    },
    {
      id: 9,
      Name: "Blue Jeans",
      price: 59.99,
      category: "Pants",
      image: {
        url: getImageUrl("Screenshot%202025-07-06%20at%2014.16.36.png"),
      },
    },
  ];

  // Fallback filtering logic
  const fallbackValidItems = fallbackItems;
  const fallbackShoes = fallbackValidItems.filter(
    (item) => item.category === "Shoes"
  );
  const fallbackTShirts = fallbackValidItems.filter(
    (item) => item.category === "T-Shirts"
  );
  const fallbackPants = fallbackValidItems.filter(
    (item) => item.category === "Pants"
  );

  return useFallback ? (
    <Box width="80%" margin="80px auto">
      <section id="featured" aria-label="Our Featured Products"></section>
      <Typography variant="h3" textAlign="center">
        Our Featured <b>Products</b>
      </Typography>
      <Tabs
        textColor="primary"
        indicatorColor="primary"
        value={value}
        onChange={handleChange}
        centered
        TabIndicatorProps={{ sx: { display: breakPoint ? "block" : "none" } }}
        sx={{
          m: "25px",
          "& .MuiTabs-flexContainer": {
            flexWrap: "wrap",
          },
        }}
      >
        <Tab label="ALL" value="all" />
        <Tab label="T-SHIRTS" value="T-Shirts" />
        <Tab label="PANTS" value="Pants" />
        <Tab label="SHOES" value="Shoes" />
      </Tabs>
      <Box
        margin="0 auto"
        display="grid"
        gridTemplateColumns="repeat(auto-fill, 300px)"
        justifyContent="center"
        rowGap="20px"
        columnGap="1.33%"
        sx={{
          "@media (max-width:600px)": {
            justifyContent: "center",
          },
        }}
      >
        {value === "all" &&
          fallbackValidItems.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
        {value === "T-Shirts" &&
          fallbackTShirts.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
        {value === "Pants" &&
          fallbackPants.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
        {value === "Shoes" &&
          fallbackShoes.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
      </Box>
    </Box>
  ) : (
    <Box width="80%" margin="80px auto">
      <section id="featured" aria-label="Our Featured Products"></section>
      <Typography variant="h3" textAlign="center">
        Our Featured <b>Products</b>
      </Typography>
      <Tabs
        textColor="primary"
        indicatorColor="primary"
        value={value}
        onChange={handleChange}
        centered
        TabIndicatorProps={{ sx: { display: breakPoint ? "block" : "none" } }}
        sx={{
          m: "25px",
          "& .MuiTabs-flexContainer": {
            flexWrap: "wrap",
          },
        }}
      >
        <Tab label="ALL" value="all" />
        <Tab label="NEW ARRIVALS" value="newArrivals" />
        <Tab label="BEST SELLERS" value="bestSellers" />
        <Tab label="TOP RATED" value="topRated" />
      </Tabs>
      <Box
        margin="0 auto"
        display="grid"
        gridTemplateColumns="repeat(auto-fill, 300px)"
        justifyContent="center"
        rowGap="20px"
        columnGap="1.33%"
        sx={{
          "@media (max-width:600px)": {
            justifyContent: "center",
          },
        }}
      >
        {value === "all" &&
          validItems.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
        {value === "newArrivals" &&
          newArrivalsItems.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
        {value === "bestSellers" &&
          bestSellersItems.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
        {value === "topRated" &&
          topRatedItems.map((item) => (
            <Item item={item} key={`${item.Name}-${item.id}`} />
          ))}
      </Box>
    </Box>
  );
};

export default ShoppingList;
